import { TTooltip } from './tooltip';

let maxId = 0;

export class ApiaUtilTooltip {
  id = `tooltip__${maxId++}`;

  constructor(
    public props: TTooltip,
    public close: () => void,
  ) {}
}
